import axiosConnect, { getBackendURL } from "../../../utils/axiosConnect";

/**
 * Shared HTTP client for patient-channel EMR calls.
 * Reuses the app-wide axiosConnect instance, which handles the onprem/cloud
 * base URL, session cookies, CSRF tokens and timeout retries.
 */
export var apiClient = axiosConnect;

/**
 * Resolves the active REST API base URL (onprem vs cloud), falling back to the
 * local backend, for callers that need an absolute endpoint string.
 */
export function getApiBaseUrl() {
  return getBackendURL() || "http://localhost:8000";
}